import script from "./BasicInfoSp.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicInfoSp.vue?vue&type=script&setup=true&lang=js"

import "./BasicInfoSp.vue?vue&type=style&index=0&id=61bd9680&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61bd9680"]])

export default __exports__